import { f7, useStore } from 'framework7-react';
import { FC, ReactNode } from 'react';
import { PageTemplate } from '@/components/uiParts/Template/PageTemplate/PageTemplate';
import { AuthInfoState, SelectedTenant } from '@/config/initialState';
import { paths } from '@/config/paths';
import { store } from '@/config/store';
import { Customer } from '@/types/api/customerApi';
import { isCustomerInfoAffiliateStale } from '@/utils/customerInfoSync';
import { selectedTenantFor } from '@/utils/selectedTenant';
import { storeDispatch } from '@/utils/store';

export const TenantSyncGate: FC<{ children: ReactNode }> = ({ children }) => {
  const authInfo = useStore(store, 'authInfo') as AuthInfoState;
  const customerInfo = useStore(store, 'customerInfo') as Customer;
  const selectedTenant = useStore(store, 'getSelectedTenant') as SelectedTenant;
  const loadedAffiliateId = useStore(store, 'getCustomerInfoAffiliateId') as
    | number
    | null;
  const tenant = selectedTenantFor(authInfo.m_customer_id, selectedTenant);
  const isStale =
    customerInfo.id === authInfo.m_customer_id &&
    tenant !== null &&
    isCustomerInfoAffiliateStale(tenant.m_affiliate_id, loadedAffiliateId);

  if (!isStale) return <>{children}</>;

  return (
    <PageTemplate pageName="tenant-sync" title="表示先の確認" showNavBack>
      <div style={{ padding: '32px 16px', textAlign: 'center' }} role="alert">
        <p>ショッピング先の情報を確認できませんでした。</p>
        <button
          type="button"
          onClick={() => f7.view.main.router.navigate(paths.home)}
        >
          ホームで再試行
        </button>
        <button
          type="button"
          onClick={async () => {
            await storeDispatch('setSelectedTenant', 'selectedTenant', null);
            f7.view.main.router.navigate(paths.home);
          }}
        >
          法人の切り替えを解除
        </button>
      </div>
    </PageTemplate>
  );
};
